/**
 * Sort containers required-first, then by display_order, then container_sort_order.
 * Returns a new array.
 *
 * Backend already orders partner containers required-first via a CASE in
 * ORDER BY, but this function is a defensive FE invariant — stale cache,
 * schema drift, and CSV export all go through `sortContainers`, and we never
 * want Product Type to render anywhere other than the leftmost column.
 */
export function sortContainers<
  T extends {
    is_required: boolean;
    display_order: number;
    container_sort_order: number;
  },
>(containers: T[]): T[] {
  return [...containers].sort(
    (a, b) =>
      (a.is_required === b.is_required ? 0 : a.is_required ? -1 : 1) ||
      a.display_order - b.display_order ||
      a.container_sort_order - b.container_sort_order,
  );
}
